import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { hoursDiff } from '../../core';
import { BaseComponent, ConvertDatePipe } from '../../shared';


/**
 * Component for last syncronization status.
 */
@Component({
	selector: 'tsp-syncronization',
	imports: [
		DatePipe,
		ConvertDatePipe
	],
	templateUrl: './syncronization.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class SyncronizationComponent extends BaseComponent {

	lastSync = input.required<Date | undefined>();

	syncImg = computed(() => {
		if (!this.lastSync() || hoursDiff(this.lastSync(), this._today) > 48) return 'images/lastSyncDate_red.png';
		else if (hoursDiff(this.lastSync(), this._today) > 24) return 'images/lastSyncDate_orange.png';
		else return 'images/lastSyncDate_green.png';
	});

	isWarning = computed(() => this.lastSync() && hoursDiff(this.lastSync(), this._today) > 48);

	private readonly _today = new Date();

}
